<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-修改
    -->
  <el-dialog title="修改分类" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form size="small" :model="form" :rules="formRules" ref="form">
      <el-form-item label="名称" prop="name" :label-width="formLabelWidth">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="简介" prop="text" :label-width="formLabelWidth">
        <el-input v-model="form.text" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="图片" prop="image" :label-width="formLabelWidth">
        <el-row>
          <el-button type="primary" @click="openUpload">选择图片</el-button>
          <div v-if="form.image!=''" class="img">
            <img :src="form.image" width="100" height="100" />
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="排序" prop="sort" :label-width="formLabelWidth">
        <el-input v-model.number="form.sort" autocomplete="off"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="addUser" :loading="loading">确 定</el-button>
    </div>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" :type="type" @returnImgs="returnImgsFunc">上传图片</Upload>
  </el-dialog>
</template>

<script>
import CallmsgApi from "@/api/callmsg.js";
import Upload from "@/components/file/Upload";
export default {
  components: {
    Upload
  },
  data() {
    return {
      form: {
        name: "",
        text: "",
        sort: 100,
        image: ""
      },
      imageId: "",
      formRules: {
        name: [
          {
            required: true,
            message: "请输入分类名称",
            trigger: "blur"
          }
        ],
        image: [
          {
            required: true,
            message: "请上传分类图片",
            trigger: "blur"
          }
        ],
        sort: [
          {
            required: true,
            message: "分类排序不能为空"
          },
          {
            type: "number",
            message: "分类排序必须为数字"
          }
        ]
      },
      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false
    };
  },
  props: ["open_edit", "editform"],
  created() {
    this.dialogVisible = this.open_edit;
    this.form.id = this.editform.model.id;
    this.form.text = this.editform.model.text;
  },
  methods: {
    /*修改用户*/
    addUser() {
      let self = this;
      let params = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          CallmsgApi.ServiceTypeEdit(params, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: "修改成功",
                type: "success"
              });
              self.dialogFormVisible(true);
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        this.form.image = e[0].filePath;
        this.imageId = e[0].fileId;
      }
      this.isupload = false;
    }
  }
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/callmsg/Edit.vue